export const experiences = [
  {
    id: 1,
    title: 'IT Designer Developer',
    company: "Business Tax",
    duration: "(2025 - Present)"
  },
  {
    id: 2,
    title: 'FullStack Developer',
    company: "Sostag / Obcom",
    duration: "(2017 - 2025)"
  },
  {
    id: 3,
    title: "Developer intern",
    company: "Obcom / R2Design",
    duration: "(2017)"
  }
] as const;